import { useCallback, useEffect, useState } from 'react';
import { Grid3x2 } from 'react-bootstrap-icons';
import { Navigate } from 'react-router-dom';

import { Col, ColProps, Row } from 'antd';
import { Gutter } from 'antd/es/grid/row';

import EmptyState from '@/components/shared/EmptyState';
import PageTitle from '@/components/shared/PageTitle';
import SkeletonBaseCard from '@/components/shared/SkeletonBaseCard';
import Wrapper from '@/components/shared/Wrapper';
import PortalProps from '@/interfaces/portals';
import portalsService from '@/services/portals';
import { isMainSubdomain } from '@/settings';

import Card from './Card';

const DEFAULT_ROWS_SPACING = [16, 16] as [Gutter, Gutter];

const DEFAULT_COLUMNS_WIDTH: Pick<ColProps, 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'> = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6,
  xxl: 6
};

const PortalsPage = () => {
  const [loading, setLoading] = useState(true);
  const [portals, setPortals] = useState<PortalProps[]>([]);

  const listPortals = useCallback(async () => {
    try {
      const data = await portalsService.list();
      setPortals(data);
      setLoading(false);
    } catch (error) {
      // TODO: handle error
    }
  }, []);

  useEffect(() => {
    if (isMainSubdomain) listPortals();
  }, [listPortals]);

  const hasPortals = portals?.length > 0;

  if (!isMainSubdomain) return <Navigate to='/resumo' />;

  return (
    <Wrapper>
      <PageTitle title='Portais' />

      {loading && (
        <Row gutter={DEFAULT_ROWS_SPACING}>
          {new Array(8).fill('').map((_, index) => (
            <Col {...DEFAULT_COLUMNS_WIDTH} key={index}>
              <SkeletonBaseCard aspect='1:1' />
            </Col>
          ))}
        </Row>
      )}

      {!loading && !hasPortals && (
        <EmptyState
          icon={<Grid3x2 />}
          title='Todos seus portais aparecerão aqui...'
          description='Aqui você poderá visualizar todos os portais que você possui acesso.'
        />
      )}

      {!loading && hasPortals && (
        <Row gutter={DEFAULT_ROWS_SPACING}>
          {portals.map(portal => (
            <Col {...DEFAULT_COLUMNS_WIDTH} key={portal.id}>
              <Card {...portal} />
            </Col>
          ))}
        </Row>
      )}
    </Wrapper>
  );
};

export default PortalsPage;
